import constants from 'common/constants'

import {ONBOARDING_LESSON_PLANNING_TEMPLATE} from './ActionTypes/ApiActionTypes'

/* Get the S3 URL of the Lesson Planning sample excel template */
export const downloadLessonPlanningTemplate = (onSuccess, onFailure) => {
  return {
    type: ONBOARDING_LESSON_PLANNING_TEMPLATE,
    payload: {
      apiUrl: constants.api_onboarding_lesson_planning_template,
      getString: '',
      useBaseURL: true,
      requestType: 'GET',
      header: 'application/json',
      reduxActionType: '',
      body: null,
      onSuccess,
      onFailure,
    },
  }
}
